import csc from 'country-state-city';

export function useCountryStates(countryCode: string) {
  const states = csc.getStatesOfCountry(countryCode);
  return {
    states: states.map(({ name }) => ({ id: name.split(' ')[0], name })),
  };
}
